import Titol from 'components/3catinfo/Titol';
import clsx from 'clsx';
import styles from './capcaleraGrafic.module.scss';

const CapcaleraGrafic = (props) => {
    const { titol, className, estil, tag } = props;
    const stylesCapcalera = clsx({
        [styles.contentCapcalera]: true,
        [className]: !!className,
        [styles[estil]]: !!estil
    });

    return (
        <div className={stylesCapcalera}>
            <Titol tag={tag || 'h3'} titol={titol} className={styles.titol} />
        </div>
    );
};

export default CapcaleraGrafic;
